/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'jquery',
	'../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/illustrations-js/disconnect_64',
	'../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/illustrations-js/unknown-warning_128'

], function(
	_,
	React,
	ReactDOM,
	UI_Toolkit,
	PropTypes,
	$,
	disconnect,
	permission
) {
	const { Container, FlexLayout, FlexItem, VSpacer, SVGIcon, Label } = UI_Toolkit;
	const { Component } = React;

	class ExtensibleErrorComponent extends Component {
		constructor (...args) {
			super(...args);
		}

		render () {
			return (
				<Container className='vis-sdk-error-container'>
					<FlexLayout fullHeight direction="column" flex-wrap= "wrap" justifyContent='center' alignItems='center'>
						<FlexItem>
							<SVGIcon iconId={this.props.context.default.id} height={128} width={128}></SVGIcon>
						</FlexItem>

						<VSpacer size={3}/>

						<FlexLayout fullHeight direction="column" flex-wrap= "wrap" justifyContent="center">
							<FlexItem>
								<Label className='vis-sdk-error-header' label={this.props.title}/>
							</FlexItem>
						</FlexLayout>

						<VSpacer/>

						<FlexLayout fullHeight direction="column" flex-wrap= "wrap" justifyContent='center'>
							<FlexItem>
								<Label className='vis-sdk-error-msgContent' label={this.props.msgContent}/>
							</FlexItem>
						</FlexLayout>

						<VSpacer/>
					</FlexLayout>
				</Container>
			);
		}
	}

	ExtensibleErrorComponent.propTypes = {
		title: PropTypes.object.isRequired,
		msgContent: PropTypes.object.isRequired,
		context: PropTypes.object.isRequired

	};

	return class SdkShowError {
		constructor (el, title, msgContent, context) {
			this.title = title;
			this.msgContent = msgContent;
			this.el = el;
			this.context = context === 'disconnect' ? disconnect : permission;
		}

		showError() {
			this.$errorContainerWrapper = $('<div class="vis-sdk-error-container-wrapper errorContainer"></div>');
			this.el.append(this.$errorContainerWrapper[0]);

			ReactDOM.render(<ExtensibleErrorComponent title={this.title} msgContent={this.msgContent} context={this.context} />, this.$errorContainerWrapper[0]);
		}

		destroy () {
			if (this.$errorContainerWrapper) {
				ReactDOM.unmountComponentAtNode(this.$errorContainerWrapper[0]);
			}
		}

	};
});
